import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 48px;
`;

const SectionTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 30px;
  margin-top: 20px;
  color: var(--text-color);
`;

const CookiesContent = styled.div`
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 120px;
  
  h2 {
    font-size: 1.8rem;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 1.4rem;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 20px;
  }
  
  ul {
    margin-bottom: 20px;
    padding-left: 20px;
    list-style-type: disc;
  }
  
  li {
    margin-bottom: 10px;
  }
`;

const CookiesPage = () => {
    return (
        <PageContainer>
            <Container>
                <SectionTitle>Cookies Policy</SectionTitle>

                <CookiesContent>
                    <p>Effective Date: [Insert Date]</p>

                    <p>This Cookies Policy explains how Interstellar Map ("we," "us," or "our") uses cookies and similar technologies on our website https://interstellarmap.com. We are committed to respecting your privacy and only use cookies when absolutely necessary to ensure a smooth and secure browsing experience.
                    </p>

                    <h2>1. What Are Cookies?</h2>
                    <p>Cookies are small text files stored on your device by your browser when you visit a website. They are used to make websites work efficiently, as well as to provide information to the website owner.</p>

                    <h2>2. How We Use Cookies</h2>
                    <p>We use only essential cookies to:</p>
                    <ul>
                        <li>Enable basic site functionality (e.g. shopping cart, user session management)</li>
                        <li>Maintain secure transactions during the checkout process</li>
                        <li>Improve performance and stability of the website</li>
                    </ul>

                    <p>We do not use:</p>

                    <ul>
                        <li>Third-party tracking tools (e.g. Google Analytics, Facebook Pixel)</li>
                        <li>Advertising or marketing cookies</li>
                        <li>Social media integration cookies</li>
                    </ul>

                    <h2>3. Types of Cookies We Use</h2>

                    <ul>
                      <li>Essential Cookies: Required for basic website functions and security</li>
                      <li>Session Cookies: Temporarily store information during your visit (e.g. cart status)</li>
                      <li>Functional Cookies: Remember your preferences and settings (if applicable)</li>
                    </ul>

                    <p>All cookies used are set by our domain and expire after a short, predefined period (typically when your session ends or within a few hours).
                    </p>

                    <h2>4. Managing Cookies</h2>
                    <p>
                    Since we only use strictly necessary cookies, you cannot opt out of them without affecting the core functionality of the site. If you wish to block all cookies, you may do so via your browser settings; however, this may limit your ability to place orders or navigate the site properly.
                    </p>

                    <h2>5. Changes to This Policy</h2>
                    <p>
                    We may update this Cookies Policy if our use of cookies changes or if required by law. Changes will be posted on this page with an updated effective date.
                    </p>

                    <h2>6. Contact Us
                    </h2>
                    <p>
                    If you have any questions about your order or this policy, please contact:
                    </p>
                    <ul>
                        <li>Email: info@interstellarmap.com</li>
                        <li>Website: https://interstellarmap.com</li>
                    </ul>
                </CookiesContent>
            </Container>
        </PageContainer>
    );
};

export default CookiesPage; 